import {
  ApiDeleteRequest,
  ApiGetRequest,
  ApiPostRequest,
  ApiPutRequest,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title_cost: 'Damage Cost',
    title_estimate: 'Estimate Cost',
    title_estimate_form: 'Form Estimate Cost',
    breadcrumb_cost: [
      {
        text: 'Dashboard',
        href: '/',
      },
      {
        text: 'EOR',
        href: '/opc/eor/estimate-cost',
        active: true,
      },
    ],
    title_wo: 'Work Order',
    breadcrumb_wo: [
      {
        text: 'Dashboard',
        href: '/',
      },
      {
        text: 'Work Order',
        href: '/opc/eor/work-order',
        active: true,
      },
    ],
    breadcrumb_estimate: [
      {
        text: 'Dashboard',
        href: '/',
      },
      {
        text: 'Estimate Cost',
        href: '/opc/eor/estimate-cost',
        active: true,
      },
    ],
    items: [],
    items_wo: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'age',
    sortDesc: true,
    fields_cost: [
      {
        key: 'code_eor',
        label: 'EOR No',
        sortable: true,
      },
      {
        key: 'eor_date',
        label: 'Date',
        sortable: true,
      },
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
        sortable: true,
      },
      {
        key: 'size',
        label: 'Size',
      },
      {
        key: 'type',
        label: 'Type',
      },
      {
        key: 'code_survey',
        label: 'Survey No',
      },
      {
        key: 'approval',
        label: 'Approval',
      },
      {
        key: 'approval_no',
        label: 'Approval No',
      },
      {
        key: 'aksi',
      },
    ],
    fields_choose_container: [
      {
        key: 'code_survey',
        label: 'Survey',
        sortable: true,
      },
      {
        key: 'survey_date',
        label: 'Date',
        sortable: true,
      },
      {
        key: 'doc_no',
        label: 'B/L No',
        sortable: true,
      },
      {
        key: 'exvessel_voy',
        label: 'Exvessel/Voy',
        sortable: true,
      },
      {
        key: 'container',
        label: 'Container',
        sortable: true,
      },
      {
        key: 'size',
        label: 'Size',
      },
      {
        key: 'type',
        label: 'Type',
        sortable: true,
      },
      {
        key: 'cleaning',
        label: 'Cleaning',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    items_survey: [],
    form_estimate: {
      id_principle: '',
      code_principle: '',
      principle: '',
      containers: [],
    },
  },
};

export const getters = {
  form_estimate(state) {
    return state.data.form_estimate;
  },
};

export const mutations = {
  changeEor(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getListEor({ commit, state }) {
    commit('changeEor', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`opr/eor`, params);
    commit('changeEor', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getListContSurvey({ commit, state }) {
    commit('changeEor', {
      loading: true,
    });

    const { data } = state;
    let container_id = [];
    data.form_estimate.containers.map((item) =>
      container_id.push(item.id_container)
    );

    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: 'id_survey_in',
      order: data.sortDesc ? 'desc' : 'asc',
      id_principle: data.form_estimate.id_principle || '',
      containers: container_id ? container_id.join(',') : '',
    };

    let result = await ApiGetRequest(`opr/eor/survey`, params);
    commit('changeEor', {
      items_survey: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailEOR({ commit }, payload = null) {
    commit('changeEor', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/eor/${payload.id}`);
    commit('changeEor', {
      loading: false,
    });

    if (!result.error) {
      commit('changeEor', {
        form_estimate: {
          ...result.data.object,
        },
      });
    }

    return !result.error ? true : false;
  },

  async createEOR({ commit, state, dispatch }) {
    commit('changeEor', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`opr/eor`, data.form_estimate);
    commit('changeEor', {
      loading: false,
    });
    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async updateEOR({ commit, state, dispatch }, payload = null) {
    commit('changeEor', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPutRequest(
      `opr/eor/${payload.id}`,
      data.form_estimate
    );
    commit('changeEor', {
      loading: false,
    });
    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },

  async deleteEOR({ commit, dispatch }, payload = null) {
    commit('changeEor', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/eor/${payload.id}`);
    commit('changeEor', {
      loading: false,
    });
    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return true;
    }

    return false;
  },
};
